import React from 'react';


/**
 * Modal radio buttons that deal with selecting image type.
 * @param prop.currentOption String that indication the selected imagetype.
 * @param props.handleRadioButtonChange Function that deals with changes made to radio button.
 * @return JSX
 */
export function CdaWebModalRadioButton(props) {

    const {currentOption, handleRadioButtonChange } = props;
    const allOptions = ['png', 'pdf'];

    return (
            <div className='cdaWebModalRadioButtonGroup'>
              <span className='cdaWebModalRadioButtonLabel'>Plot Image Format:</span>
              {allOptions.map((el) => (
                <div className="" key={el}>
                  <label>
                    <input
                      type="radio"
                      value={el}
                      checked={currentOption === el}
                      onChange={(e)=>handleRadioButtonChange(e)} />{el.toUpperCase()}
                  </label>
                </div>))}
            </div>
    );
}
